// Contact form submission seam.
// No backend is wired up yet — replace the body of submitOutreach with a real
// POST (Formspree, Supabase, API route…) when one is chosen; the form
// component won't need to change. Keep personal contact details out of this
// file: anything here ships in the public bundle.
export function submitOutreach(data) {
  console.warn("Contact form backend not configured; submission not delivered.", data);
  return false;
}
